export const options = { 
    Home: { url: '/' }, 
    Boarding: { url: '/boarding' }, 
    Daycare: { url: '/daycare' }, 
    Grooming: { url: '/grooming' }, 
    Forms: { url: '/forms' },
}